export enum HSCodeStatus {
     Inactive = 0,
    Active = 1
}